// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1bhd5","col":"styles_col__2i1wb","fulfillmentStatus":"styles_fulfillmentStatus__3559n","emailCol":"styles_emailCol__2fCr3"};